// Rétention des vidéos brutes côté UI.
// Le Worker supprime de R2 les vidéos uploadées passé un délai (cleanup R2
// planifié, voir worker.js cleanupExpiredVideos / VIDEO_RETENTION_MS). Côté
// front, on ne doit donc pas afficher un lecteur cassé pour un débrief plus
// ancien que cette rétention : on montre un message clair à la place, tout en
// gardant l'analyse (ai_raw_response, frame_previews, etc.) en dessous.
//
// On garde la même fenêtre que le Worker (15 min). La fonction est volontairement
// tolérante : sur date invalide on considère la vidéo NON expirée (on préfère
// tenter d'afficher le lecteur plutôt que de masquer à tort).

export const VIDEO_RETENTION_MS = 15 * 60 * 1000;

// Vrai si un débrief créé à `createdAt` a dépassé la rétention vidéo à l'instant
// `now`. `createdAt` accepte un timestamp epoch (ms) ou une chaîne ISO.
export function isVideoExpired(createdAt, now = Date.now(), retentionMs = VIDEO_RETENTION_MS) {
  const t = typeof createdAt === 'number' ? createdAt : Date.parse(createdAt);
  if (!Number.isFinite(t)) return false;
  return now - t > retentionMs;
}
